var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUdemy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 46,
    viewBox: "0 0 24 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6925 13.6792L11.8446 6.83965L0 13.6792V6.83965L11.8462 0L23.6942 6.83965V13.6792H23.6925Z",
    fill: "#A435F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.4229H6.20556V34.5001C6.20556 38.3954 9.11448 40.2942 11.8462 40.2942C14.6016 40.2942 17.4886 38.3449 17.4886 34.4478V19.4229H23.6942V34.8592C23.6942 38.4477 22.566 41.2166 20.3098 43.1153C18.0518 45.0125 15.2323 45.9365 11.794 45.9365C8.35895 45.9365 5.53777 45.0141 3.33384 43.1154C1.12816 41.2182 0 38.5522 0 35.0126V19.4229Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6942,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdemy);
export default __webpack_public_path__ + "static/media/udemy.577c59315491fec43495794fda5dbfc3.svg";
export { ForwardRef as ReactComponent };